import { render, staticRenderFns } from "./user-single.vue?vue&type=template&id=e2b035dc&"
import script from "./user-single.vue?vue&type=script&lang=js&"
export * from "./user-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports